import React, { useState } from 'react';
import { Button, Divider, Icon, Popover, Tooltip } from 'antd';
import { ColorCellHorPopover, ColorCellVerPopover } from '../styles';
import { CHART_TRANSLATION } from '../translationValues';

export const ChartColorCell = ({ index, deleteRow, addRow, addActions = true, t }) => {
  const [showPrimaryPopover, setShowPrimaryPopover] = useState(false);
  const [showSecondaryPopover, setShowSecondaryPopover] = useState(false);

  const addRowAtIndex = rowIndex => {
    setShowPrimaryPopover(false);
    setShowSecondaryPopover(false);
    addRow(rowIndex);
  };

  const verticalPopoverContent = (
    <ColorCellVerPopover>
      <ul>
        <li onClick={() => addRowAtIndex(index)}>
          {t(
            CHART_TRANSLATION.INSERT_BEFORE_LABEL.key,
            CHART_TRANSLATION.INSERT_BEFORE_LABEL.value,
          )}
        </li>
        <li onClick={() => addRowAtIndex(index + 1)}>
          {t(CHART_TRANSLATION.INSERT_AFTER_LABEL.key, CHART_TRANSLATION.INSERT_AFTER_LABEL.value)}
        </li>
      </ul>
    </ColorCellVerPopover>
  );

  const horizontalPopoverContent = (
    <ColorCellHorPopover>
      <Tooltip
        title={t(CHART_TRANSLATION.DELETE_ROW_LABEL.key, CHART_TRANSLATION.DELETE_ROW_LABEL.value)}
        placement="bottom"
      >
        <Button onClick={() => deleteRow(index)}>
          <Icon type="delete" />
        </Button>
      </Tooltip>
      {addActions && (
        <>
          <Divider type="vertical" />
          <Tooltip
            title={t(CHART_TRANSLATION.MORE_LABEL.key, CHART_TRANSLATION.MORE_LABEL.value)}
            placement="bottom"
          >
            <Popover
              content={verticalPopoverContent}
              trigger="click"
              placement="bottomLeft"
              overlayClassName="chart-vertical-popover"
              visible={showSecondaryPopover}
              onVisibleChange={vis => setShowSecondaryPopover(vis)}
            >
              <Button>
                <Icon type="ellipsis" />
              </Button>
            </Popover>
          </Tooltip>
        </>
      )}
    </ColorCellHorPopover>
  );

  return (
    <Popover
      content={horizontalPopoverContent}
      trigger="click"
      overlayClassName="chart-hor-popover"
      visible={showPrimaryPopover}
      onVisibleChange={vis => {
        setShowPrimaryPopover(vis);
        if (!vis) {
          setShowSecondaryPopover(false);
        }
      }}
    >
      <Icon type="ellipsis" />
    </Popover>
  );
};
